import request from "@/utils/request";

export function getRechargeRecord(query) {
  return request({
    url: "/api/merchant/recharge/record",
    method: "get",
    params: query
  });
}

export function getRecordInfo() {
  return request({
    url: "/api/merchant/recharge/record-info",
    method: "get"
  });
}

export function alipay(query) {
  return request({
    url: "/api/merchant/pay/wap/alipay",
    method: "post",
    data: query
  });
}

export function wxpayFirst(query) {
  return request({
    url: "/api/merchant/pay/wx/first",
    method: "post",
    data: query
  });
}

export function wxpaySecond(query) {
  return request({
    url: "/api/merchant/pay/wx/second",
    method: "post",
    data: query
  });
}

export function getPayRecharge(query) {
  return request({
    url: "/api/merchant/pay/getRecharge",
    method: "get",
    params: query
  });
}

export function wxpayNotify(query) {
  return request({
    url: "/api/merchant/pay/wap/wxpay/notify",
    method: "post",
    data: query
  });
}

export function getOrderList(query) {
  console.log(query);
  return request({
    url: "/api/merchant/product-order/list",
    method: "get",
    params: query
  });
}
// 申请开通会员产品
export function openVipProduct(query) {
  return request({
    url: "/api/merchant/product/openVipProduct",
    method: "post",
    data: query
  });
}
// 开通会员详情
export function openVipDetail(query) {
  return request({
    url: "/api/merchant/members-order/payResult",
    method: "get",
    params: query
  });
}
export function getInvoiceOrderList(query) {
  console.log(query);
  return request({
    url: "/api/merchant/product-order/invoice-list",
    method: "get",
    params: query
  });
}

export function getOrderDetail(query) {
  return request({
    url: "/api/merchant/product-order/detail",
    method: "get",
    params: query
  });
}

export function getOrderInfo(query) {
  return request({
    url: "/api/merchant/product-order/detail-info",
    method: "get",
    params: query
  });
}

export function orderPay(query) {
  return request({
    url: "/api/merchant/product-order/pay",
    method: "post",
    data: query
  });
}

export function cancelOrder(query) {
  return request({
    url: "/api/merchant/product-order/cancel",
    method: "post",
    data: query
  });
}

export function deleteOrder(query) {
  return request({
    url: "/api/merchant/product-order/delete",
    method: "post",
    data: query
  });
}

export function publishcomment(query) {
  return request({
    url: "/api/merchant/product-comment/comment",
    method: "post",
    data: query
  });
}

export function getCommentDetail(query) {
  return request({
    url: "/api/merchant/product-comment/detail",
    method: "get",
    params: query
  });
}

export function getCommentInfo(query) {
  return request({
    url: "/api/merchant/product-comment/info",
    method: "get",
    params: query
  });
}

export function createOrder(query) {
  return request({
    url: "/api/merchant/product-order/create",
    method: "post",
    data: query
  });
}
export function createMessageOrder(query) {
  return request({
    url: "/api/merchant/product-order/createSms",
    method: "post",
    data: query
  });
}
export function getProductDetail(query) {
  return request({
    url: "/api/merchant/product/detail",
    method: "get",
    params: query
  });
}

export function getCouponList(query) {
  return request({
    url: "/api/merchant/activity/coupon/list",
    method: "get",
    params: query
  });
}

export function getCouponUselist(query) {
  return request({
    url: "/api/merchant/activity/coupon/uselist",
    method: "get",
    params: query
  });
}

export function getTotalPayment(query) {
  return request({
    url: "/api/merchant/activity/getTotalPayment",
    method: "get",
    params: query
  });
}

export function getListCommission(query) {
  return request({
    url: "/api/merchant/activity/listCommission",
    method: "get",
    params: query
  });
}

export function getCommissionDetail(query) {
  return request({
    url: "api/merchant/activity/admin/commissionDetail",
    method: "get",
    params: query
  });
}



// WEBPACK FOOTER //
// ./src/services/finance.js